@if (institutionId > 0) {
  <div id="submodule-additional-data" class="cw-module-card" style="width: 100%">
    <div class="cw-flex-row">
      <h2>Umsatz</h2>
    </div>
    <!-- TODO verallgemeinern das mehrere data_type möglich sind (auch kundenspezifisch)-->
    <phscw-output-additional-data
      [entity_id]="institutionId"
      data_type="kpis"
      entity_type="institutions"
      style="width: 100%"
      id="additional-data">
    </phscw-output-additional-data>
  </div>
}
